import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import Files from "react-files";
import { useToggleState } from "../../../Hooks/useToggleState";
import { BASE_URL_IMAGE } from "../../../Api/client";
import CustomModal from "../Modal";
import { validFileExtensions } from "../../../helpers/fileValidationRules";
import { AiOutlineEye } from "react-icons/ai";
import { LuDownload } from "react-icons/lu";
import { IoMdCloseCircle } from "react-icons/io";
import { IoCloseSharp } from "react-icons/io5";

const MultipleFileUpload = ({
   label,
   onChange,
   existingValue = "",
   value = [],
   accepts = [],
   errors = false,
   message = "",
   onRemoveExistingFiles = () => {},
}) => {
   const [existingFiles, setExistingFiles] = useState([]);
   const [removedFiles, setRemovedFiles] = useState([]);
   let _removedFiles = [];

   const [isImageModalVisible, handleShowImageModal, handleCloseImageModal] =
      useToggleState();

   const handleChange = (files) => {
      onChange(files);
   };

   useEffect(() => {
      if (existingValue.length > 0) {
         const oldFiles = existingValue?.split?.("<=> ");
         setExistingFiles(oldFiles);
      } else {
         setExistingFiles([]);
      }
   }, [existingValue]);

   const handleDownload = (event, url, fileExtention) => {
      event.preventDefault(); // Prevent default form submission behavior
      event.stopPropagation(); // Prevent the modal from closing
      const link = document.createElement("a");
      link.href = url; // Path to your document
      link.download = `document.${fileExtention}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   };

   function getDocument(document, onRemove = () => {}) {
      let fileExtention = "";
      let url = "";
      let filename = "";

      if (document && typeof document === "object") {
         url = URL.createObjectURL(document);
         const documentName = document.name.toLowerCase();
         filename = documentName;
         fileExtention = documentName.split(".").pop();
      } else {
         url = `${BASE_URL_IMAGE}${document}`;
         fileExtention = document.split(".").pop();
         filename = document;
      }

      if (validFileExtensions.image.includes(fileExtention)) {
         return (
            <div
               style={{
                  width: 300,
                  height: 300,
                  borderRadius: 12,
                  overflow: "hidden",
                  position: "relative",
               }}
               className="border shadow-lg"
            >
               <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                     position: "absolute",
                     right: 10,
                     top: 5,
                     width: 19.5,
                     height: 19.5,
                     borderRadius: "50%",
                     backgroundColor: "red",
                     cursor: "pointer",
                  }}
                  onClick={onRemove}
               >
                  <IoCloseSharp color="#fff" size={18} />
               </div>
               <img
                  src={url}
                  alt=""
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
               />
            </div>
         );
      }

      if (validFileExtensions.document.includes(fileExtention)) {
         if (fileExtention === "pdf") {
            return (
               <div
                  style={{
                     width: 300,
                     height: 300,
                     borderRadius: 12,
                     overflow: "hidden",
                     position: "relative",
                  }}
                  className="border shadow-lg"
               >
                  <div
                     className="d-flex justify-content-center align-items-center"
                     style={{
                        position: "absolute",
                        right: 10,
                        top: 5,
                        width: 19.5,
                        height: 19.5,
                        borderRadius: "50%",
                        backgroundColor: "red",
                        cursor: "pointer",
                     }}
                     onClick={onRemove}
                  >
                     <IoCloseSharp color="#fff" size={18} />
                  </div>
                  <object data={url} style={{ width: 300, height: 300 }}></object>{" "}
               </div>
            );
         } else {
            return (
               <div
                  style={{
                     width: 300,
                     height: 300,
                     borderRadius: 12,
                     overflow: "hidden",
                     backgroundColor: "#f6f6f6",
                     gap: 10,
                     position: "relative",
                  }}
                  className="border shadow-lg d-flex flex-column justify-content-center align-items-center gap-2"
               >
                  <div
                     className="d-flex justify-content-center align-items-center"
                     style={{
                        position: "absolute",
                        right: 10,
                        top: 5,
                        width: 19.5,
                        height: 19.5,
                        borderRadius: "50%",
                        backgroundColor: "red",
                        cursor: "pointer",
                     }}
                     onClick={onRemove}
                  >
                     <IoCloseSharp color="#fff" size={18} />
                  </div>
                  <button
                     onClick={(event) => handleDownload(event, url, fileExtention)}
                     className="border d-flex justify-content-center align-items-center"
                     style={{
                        width: 60,
                        height: 52,
                        backgroundColor: "rgba(0,0,0,0.05)",
                        borderRadius: 8,
                        cursor: "pointer",
                     }}
                  >
                     <LuDownload size={28} color="rgba(0,0,0,0.8)" />
                  </button>
                  <div style={{ padding: "0 10px", flexWrap: "wrap" }}>
                     <p>{filename}</p>
                  </div>
               </div>
            );
         }
      }

      return url;
   }

   function hasFile() {
      return value?.length + existingFiles.length > 0;
   }
   function fileCount() {
      return value?.length + existingFiles.length;
   }

   const handleError = (error, file) => {};

   const handleCloseModal = () => {
      handleCloseImageModal();
   };

   const handleRemoveCurrentFile = (index) => {
      const currentFiles = Array.isArray(value) ? [...value] : [];
      currentFiles.splice(index, 1);

      handleChange(currentFiles);
      if (currentFiles.length < 1) {
         handleCloseModal();
      }
   };

   const handleRemoveExistingFile = (index) => {
      const _existingFiles = [...existingFiles];
      const _removedFile = _existingFiles?.splice?.(index, 1);
      setExistingFiles(_existingFiles);
      setRemovedFiles((prev) => [...prev, _removedFile]);
      _removedFiles.push(_removedFile);

      const existingFileString = _existingFiles.join("<=> ");
      const removedFileString = _removedFiles.join("<=> ");

      onRemoveExistingFiles(existingFileString, removedFileString);

      if (_existingFiles.length < 1) {
         handleCloseImageModal();
      }
   };

   return (
      <>
         <CustomModal
            showModal={isImageModalVisible}
            handleCloseModal={handleCloseModal}
            hideFooter={true}
            modalSize="modal-xl"
            modalHeight="80vh"
            title="View Document"
            // onSubmit={handleAgreementDocumentUpdate}
            child={
               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  {existingFiles?.map?.((item, index) => (
                     <div key={index}>
                        {getDocument(item, () => handleRemoveExistingFile(index))}
                     </div>
                  ))}
                  {value?.map?.((item, index) => (
                     <div key={index}>
                        {getDocument(item, () => handleRemoveCurrentFile(index))}
                     </div>
                  ))}
               </div>
            }
         />

         <div className="files d-flex align-items-end w-100">
            <Files
               className="files-dropzone flex-grow-1"
               onChange={handleChange}
               onError={handleError}
               accepts={["image/png", ".pdf", "audio/*", ...accepts]}
               multiple
               maxFileSize={1000000}
               minFileSize={0}
               clickable
            >
               <label htmlFor="AgreementDetails">
                  {label}
                  <span className="text-danger">*</span>
               </label>

               <div
                  className="drop-files form-control"
                  style={{ height: 38, display: "flex", alignItems: "center" }}
               >
                  <button type="button" className="mr-1" style={{ fontSize: 14 }}>
                     Choose File
                  </button>
                  {fileCount() === 1
                     ? value?.[0]?.name || existingFiles?.[0]
                     : fileCount() > 1
                     ? `${fileCount()} Files Uploaded`
                     : "No File Choosen"}
               </div>
            </Files>

            {hasFile() && (
               <Button
                  variant="contained"
                  style={{ height: 37, marginLeft: 8 }}
                  onClick={handleShowImageModal}
               >
                  View
               </Button>
            )}
         </div>
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </>
   );
};

export default MultipleFileUpload;
